import { customFetch } from '../../../../../shared/customFetch';
import { API_ROUTES } from '../../../../shared/ApiRoutes';

export const getUserPortefeuille = (userId: string) => {
  return customFetch.get(API_ROUTES.PORTEFEUILLE.USER_PORT(userId));
};

export const getUserPortefeuilleKPI = (userId: string) => {
  return customFetch.get(API_ROUTES.PORTEFEUILLE.KPI(userId));
};

export const getUserKYC = (userId: string) => {
  return customFetch.get(API_ROUTES.KYC.USER(userId));
};

export const getDetenteurKYC = (userId: string) => {
  return customFetch.get(API_ROUTES.KYC.DETENTEUR(userId));
};

export const addKYC = (data: any) => {
  return customFetch.postformdata(API_ROUTES.KYC.BASE(), data);
};

export const updateKYC = (id: any, data: any) => {
  return customFetch.putformdata(API_ROUTES.KYC.BASE() + id + '/', data);
};

export const addAML = (data: any) => {
  return customFetch.postformdata(API_ROUTES.AML.BASE(), data);
};

export const updateAML = (id: any, data: any) => {
  return customFetch.putformdata(API_ROUTES.AML.BASE() + id + '/', data);
};

export const getUserAML = (userId: string) => {
  return customFetch.get(API_ROUTES.AML.USER(userId));
};

export const getDetenteurAML = (userId: string) => {
  return customFetch.get(API_ROUTES.AML.DETENTEUR(userId));
};
